import { FC, useEffect, useState } from 'react';

import { usePlans } from '../../../lib/api/gql/hooks/usePlans';
import { useChat } from '../../../lib/context/chat/ChatContext';
import { Button } from '../../atoms/Button';
import { CloseIcon } from '../../atoms/icons/CloseIcon';
import { RefreshIcon } from '../../atoms/icons/RefreshIcon';
import { PlanCard } from '../PlanCard/PlanCard';
import { PlanComponentUpdated } from '../PlanComponentUpdated/PlanComponentUpdated';

import styles from './PlanComponent.module.css';

export const PlanComponent: FC = () => {
    const chatContext = useChat();
    const [selectedPlan, setSelectedPlan] = useState<number | null>(0);
    const { getPlans, plans, currentPlan, updatePlan, planState } = usePlans();


    const { showChangePlan, toggleChangePlan } = chatContext;

    useEffect(() => {
        if (currentPlan) {
            setSelectedPlan(currentPlan);
        }
    }, [currentPlan]);

    useEffect(() => {
        if (showChangePlan && plans?.length === 0) {
            console.log('showChangePlan', showChangePlan)
            getPlans();
        }
    }, [getPlans, plans?.length, showChangePlan]);

    const handleOnClick = () => {
        if (selectedPlan !== null && currentPlan !== selectedPlan) {
            updatePlan(selectedPlan);
        }
    }

    const handleOnCancel = () => {
        toggleChangePlan(false);
    }

    return (
        <>
            {showChangePlan && (
                planState?.updatePlan?.success ? (
                    <PlanComponentUpdated />
                ) : (
                    <div className={styles.planComponentModal}>
                        <h2>
                            Change your plan
                        </h2>
                        <div className={styles.planComponent}>
                            {plans?.length > 0 && (
                                plans?.map((plan) =>
                                    <PlanCard key={plan.id} isInput plan={plan} selected={plan?.id === selectedPlan} onClick={() => setSelectedPlan(plan?.id)} />
                                )
                            )}
                        </div>
                        <div className={styles.actions}>
                            <Button className={styles.cancelButton} onClick={handleOnCancel}>
                                <CloseIcon />
                                Cancel
                            </Button>
                            <Button className={styles.updateButton} onClick={handleOnClick}>
                                <RefreshIcon />
                                Update plan
                            </Button>
                        </div>
                    </div>
                )
            )}
        </>
    );
};